import { getUser } from '@frontend/auth-helpers';

const CONFIRM_SMS_DELETE = 'confirm-sms-delete';

function getStorageKey() {
  const user = getUser();
  const userId = user?.userID || '';
  return `${CONFIRM_SMS_DELETE}${userId ? `--${userId}` : ''}`;
}

export function shouldPromptForSmsDeleteConfirmation() {
  const key = getStorageKey();
  return localStorage.getItem(key) !== 'true';
}

export function dontPromptForSmsDeleteConfirmation() {
  const key = getStorageKey();
  localStorage.setItem(key, 'true');
}
